'use client';

import { useCaptureAppVersion } from '@ps/functions/hooks/useIsAppUser';

/**
 * Persists the native shell's `?appVersion=` (present only on this `/login`
 * entry URL) to `localStorage` so `isAppUser` is reliable on every later
 * creator route. Renders nothing; inert on the plain web. See
 * {@link useCaptureAppVersion}.
 */
export function AppVersionCapture() {
  useCaptureAppVersion();
  return null;
}
